import { IApplicationState } from '../../types/redux';

export const getAnalyticsUser = (state: IApplicationState) => {
  const user = state.user;

  if (!user) {
    return {};
  }

  return {
    userId: user.realtyUserId,
  };
};
